import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_DAY_NIGHT",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Definer dag/natt',
    text: 'Definer dag/natt',
    icon: 'gear',
    showOnDashboardByDefault: false,
    url: "/settings/DAY_NIGHT",
})
